var _path, _path2, _circle, _path3, _circle2, _path4, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0005 10.001H34.0005V6.00098C34.0005 5.47054 33.7898 4.96184 33.4147 4.58676C33.0396 4.21169 32.5309 4.00098 32.0005 4.00098C31.4701 4.00098 30.9614 4.21169 30.5863 4.58676C30.2112 4.96184 30.0005 5.47054 30.0005 6.00098V10.001H10.0005C8.93999 10.0022 7.92328 10.424 7.1734 11.1739C6.42352 11.9238 6.0017 12.9405 6.00049 14.001V44.001C6.0017 45.0615 6.42352 46.0782 7.1734 46.8281C7.92328 47.5779 8.93999 47.9998 10.0005 48.001H19.8394L14.4387 54.7517C14.2744 54.9568 14.1521 55.1922 14.0788 55.4446C14.0055 55.6969 13.9827 55.9612 14.0116 56.2224C14.0405 56.4836 14.1206 56.7365 14.2474 56.9668C14.3741 57.197 14.5449 57.3999 14.7501 57.5641C14.9553 57.7282 15.1909 57.8503 15.4433 57.9234C15.6957 57.9965 15.9601 58.0191 16.2212 57.9899C16.4824 57.9608 16.7353 57.8805 16.9654 57.7535C17.1955 57.6266 17.3983 57.4556 17.5623 57.2502L24.9617 48.001H39.0393L46.4387 57.2502C46.7702 57.6639 47.2524 57.9291 47.7793 57.9874C48.3062 58.0458 48.8347 57.8925 49.2487 57.5614C49.6627 57.2302 49.9282 56.7483 49.987 56.2214C50.0458 55.6946 49.893 55.166 49.5623 54.7517L44.1616 48.001H54.0005C55.061 47.9998 56.0777 47.5779 56.8276 46.8281C57.5775 46.0782 57.9993 45.0615 58.0005 44.001V14.001C57.9993 12.9405 57.5775 11.9238 56.8276 11.1739C56.0777 10.424 55.061 10.0022 54.0005 10.001Z",
    fill: "#3667B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 19C22 18.4477 22.4477 18 23 18L46 18C46.5523 18 47 18.4477 47 19C47 19.5523 46.5523 20 46 20L23 20C22.4477 20 22 19.5523 22 19Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 1,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 29C22 28.4477 22.4477 28 23 28L46 28C46.5523 28 47 28.4477 47 29C47 29.5523 46.5523 30 46 30L23 30C22.4477 30 22 29.5523 22 29Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 29,
    r: 1,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 39C22 38.4477 22.4477 38 23 38L46 38C46.5523 38 47 38.4477 47 39C47 39.5523 46.5523 40 46 40L23 40C22.4477 40 22 39.5523 22 39Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 39,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.415ed348afc9f4051c37350960032868.svg";
export { ForwardRef as ReactComponent };